import React from "react";
import {isArrayNullOrEmpty} from "../../Utilities/Types/arrayUtilities";

interface NestAdInfinitumProps {
    array: React.ComponentType<any>[];
    children: React.ReactNode;
}

export const NestAdInfinitum = ({
                                    array,
                                    children,
                                }: NestAdInfinitumProps) => {
    const newArray = array.slice(1);
    const Parent = !isArrayNullOrEmpty(array) ? array[0] : React.Fragment;

    return (
        <Parent>
            {
                !isArrayNullOrEmpty(newArray) &&
                <NestAdInfinitum array={newArray}>
                    {children}
                </NestAdInfinitum>
            }
            {
                isArrayNullOrEmpty(newArray) &&
                children
            }
        </Parent>
    );
};
